'use client'

import { useAuth } from '@clerk/nextjs'
import { apiFetch, type RequestOptions } from '@/lib/apiClient'

/**
 * Client-component variant of `apiFetch` that attaches a real Clerk session token as a
 * Bearer header — the backend's `ClerkAuthGuard` (Phase 5) requires one on every route
 * except `@Public()`. `apiFetch` itself stays Clerk-agnostic (`lib/` is the base layer);
 * this lives in `features/auth` since token acquisition is an auth concern, not a
 * generic fetch concern.
 */
export function useApiFetch() {
  const { getToken } = useAuth()

  return async function authedApiFetch<T>(path: string, options: RequestOptions = {}): Promise<T> {
    const token = await getToken()
    return apiFetch<T>(path, {
      ...options,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    })
  }
}
